import api from '@/api';

const resource = 'merenda/alimento';

export default {
  buscarAlimento() {
    return api.get( `${resource}` );
  }
};
